<div *ngIf="!submitted" class="row justify-content-center mt-5">
  <div class="col-12 col-md-8 col-lg-4 text-center">
    <h2 class="noselect">Forgot your password?</h2>
    <p class="text-muted noselect">
      Enter the email address for your account and we'll send you a link to reset your password.
    </p>
  </div>
  <div class="d-100"></div>
  <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" class="row justify-content-center w-100">
    <div class="col-12 col-md-6 col-lg-4">
      <app-input [form]="forgotForm" formGroupName="email" placeHolder="E-mail"></app-input>
    </div>
    <div class="d-100"></div>
    <div class="col-12 col-md-6 col-lg-4 mt-2">
      <button class="btn btn-primary w-100" type="submit">
        Send Reset Link
      </button>
    </div>
    <div class="d-100"></div>
    <div class="col-auto mt-3">
      <a [routerLink]="['/authentication', 'login']">Back to login</a>
    </div>
  </form>
</div>

<div *ngIf="submitted" class="row justify-content-center mt-5">
  <div class="col-12 col-md-8 col-lg-5 text-center">
    <span class="fa-solid fa-envelope-circle-check confirmation-icon"></span>
    <h2 class="noselect mt-3">Check your inbox</h2>
    <p class="text-muted noselect">
      If an account exists for that email, a password reset link has been sent.
      The link expires in 1 hour.
    </p>
    <a class="btn btn-primary mt-2" [routerLink]="['/authentication', 'login']">Back to Login</a>
  </div>
</div>
